var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoggedIn)?[_c('menu-area')]:[_c('kige-login')],_c('v-main',[_c('router-view')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }